import { WorkflowDetailsState } from "@idw-types/state/workflow-details-state";
import { WorkflowDetailsActionTypes, WorkflowDetailsActions } from "../actions/workflow-details-actions";

export const initialWorkflowDetailsState: WorkflowDetailsState = {
    advancedWorkflowDetails: {
        advancedWorkflowDetails: null,
        shouldRefreshComponentState: true,
        isLoading: false
    }
};

export const workflowDetailsReducer = (
    state: WorkflowDetailsState = initialWorkflowDetailsState,
    action: WorkflowDetailsActions
): WorkflowDetailsState => {
    switch (action.type) {
        case WorkflowDetailsActionTypes.SET_ADVANCED_WORKFLOW_DETAILS_LOADING:
            return {
                ...state,
                advancedWorkflowDetails: {
                    ...(action.payload.isLoading
                        ? { ...initialWorkflowDetailsState.advancedWorkflowDetails }
                        : { ...state.advancedWorkflowDetails }),
                    isLoading: action.payload.isLoading
                }
            };
        case WorkflowDetailsActionTypes.SET_ADVANCED_WORKFLOW_DETAILS:
            return {
                ...state,
                advancedWorkflowDetails: {
                    advancedWorkflowDetails: action.payload.advancedWorkflowDetails,
                    shouldRefreshComponentState: action.payload.shouldRefreshComponentState,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};